import { combineReducers } from 'redux'
import user from 'reducers/user-reducer'
import searchbar from 'reducers/search-reducer'
import results from 'reducers/results-reducer'
import profile from 'reducers/profile-reducer'
import watchlists from 'reducers/watchlist-reducer'
import h2h from 'reducers/h2h-reducer'
import ratings from 'reducers/ratings-reducer'
import fastTrackReg from 'reducers/fastTrackReg-reducer'
import walkUpReg from 'reducers/walkUpReg-reducer'
import psq from 'reducers/psq-reducer'
import socialMatches from 'reducers/social-matches-reducer'
import notifications from 'reducers/notifications-reducer'

export const rootReducer = combineReducers({
  user,
  searchbar,
  results,
  profile,
  h2h,
  watchlists,
  ratings,
  fastTrackReg,
  walkUpReg,
  psq,
  socialMatches,
  notifications,
})

export type AppState = ReturnType<typeof rootReducer>
export default rootReducer
